import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-select-operation-pu',
  templateUrl: './select-operation-pu.component.html',
  styleUrls: ['./select-operation-pu.component.css']
})
export class SelectOperationPuComponent implements OnInit {
    webPageName;

    public selectedBgOptions: string = '1';

    public itemsListOperations: Item[] = [];

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.webPageName = this.stateService.getStateParams()['webpagename'];
    }

    private async loadOperations() {
        if (!!this.webPageName && !!this.selectedBgOptions) {
            this.itemsListOperations = await this.datatask.Post(199, {
                webpagename: this.webPageName,
                direct: this.selectedBgOptions
            });
        }
    }

    public async goBackToPrevious(event: { item: Item; event: MouseEvent }) {
        if (!!this.itemsListOperations) {
            await this.datatask.Post(200, {
                operation_id: event.item?.item_id,
                webpagename: this.webPageName
            });

            this.stateService.back();
        }
    }

    public onTabChanged() {
        this.loadOperations();
    }

    private async init() {
        this.loadOperations();
    }

    ngOnInit() {
        this.init();
    }
}
